/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Topic_StrideInputs */

const en_ui_more_stats_topic_stride = /** @type {(inputs: Ui_More_Stats_Topic_StrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stride`)
};

const de_ui_more_stats_topic_stride = /** @type {(inputs: Ui_More_Stats_Topic_StrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt`)
};

/**
* | output |
* | --- |
* | "Stride" |
*
* @param {Ui_More_Stats_Topic_StrideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_topic_stride = /** @type {((inputs?: Ui_More_Stats_Topic_StrideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Topic_StrideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_topic_stride(inputs)
	return de_ui_more_stats_topic_stride(inputs)
});